import { useEffect } from 'react';

const getBotResponse = async (
    currentChatHistoryData,
    updateChatHistoryData,
    sendAuthorMessage,
    storyID,
    conversationID,
    userID,
    setBotResponse
) => {
    try {
        // Display a loading state in the chat history
        const addTempLoadingToChatHistory = [
            ...currentChatHistoryData,
            { role: 'loading', content: "Loading..." }
        ];
        updateChatHistoryData(addTempLoadingToChatHistory);

        // Fetch the bot's message
        const response = await fetch('https://versify-back-b066d2bc73d1.herokuapp.com/getBotMessage', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                userID: userID,
                storyID: storyID,
                conversationID: conversationID.current,
            }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setBotResponse(data.botMessage);
        await sendAuthorMessage(storyID, conversationID.current, userID, data.botMessage);

        // Update the chat history with the bot's response
        const newChatHistory = [
            ...currentChatHistoryData,
            { role: 'bot', content: data.botMessage },
        ];
        updateChatHistoryData(newChatHistory);
    } catch (error) {
        console.error('Error sending message:', error);
    }
};

export default getBotResponse;
